import React from 'react';
import { classes } from '../../../lib';
import { Card } from '../../Card';
import Styles from './NewsSection.module.less';

type NewsMentionProps = {
    logo: React.ReactNode;
    link: React.ReactNode;
    children: React.ReactNode;
};

export type NewsSectionProps = {
    children: React.ReactNode;
    title: string;
    subtitle: string;
};

const NewsMention = ({ logo, link, children }: NewsMentionProps) => {
    return (
        <Card className="vertical left-between g40 p24 shrink flex-1">
            <div className="vertical left-top g24">
                {logo}
                <span className="h4-alude alude-gray-8">{children}</span>
            </div>
            {link}
        </Card>
    );
};

export const NewsSection = ({
    title,
    subtitle,
    children,
}: NewsSectionProps): JSX.Element => {
    return (
        <section className="vertical stretch-top g40 lp-section">
            <div className="vertical stretch-top g8 text-center">
                <span className="h3-alude alude-gray-8">{title}</span>
                <span className="secondary-text semilarge-alude">
                    {subtitle}
                </span>
            </div>
            <div
                className={classes(
                    'horizontal stretch-stretch g40',
                    Styles.children
                )}>
                {children}
            </div>
        </section>
    );
};

NewsSection.Mention = NewsMention;
